import React from "react";

import "./SelectBy.scss";

import { Activity } from "react-feather";

const SelectBy = ({ options, selectedWidgets, setSelectedWidgets, activeWidgetIds }) => {

  const selectAll = () => {
    const allIds = options.map((item) => item.id);

    const allSelected =
      allIds.length > 0 &&
      allIds.every((id) => selectedWidgets.includes(id));

    if (allSelected) {
      setSelectedWidgets([]);
    } else {
      setSelectedWidgets(allIds);
    }
  };

  const selectActive = () => {
    setSelectedWidgets(activeWidgetIds);
  };

  const clearAll = () => {
    setSelectedWidgets([]);
  };

  return (
    <div className="select-by">
      <button
        type="button"
        className="select-by__button"
        onClick={selectAll}
      >
        Все виджеты
      </button>

      <button
        type="button"
        className="select-by__button"
        onClick={selectActive}
      >
        Активные виджеты <Activity color="#222" size={12} />
      </button>

      <button
        type="button"
        className="select-by__button"
        onClick={clearAll}
      >
        Убрать все виджеты
      </button>
    </div>
  );
};

export default SelectBy;